import { useCallback, useRef } from 'react';
import type { ValidationIssueFamily } from '../lib/validationIssueFamilies';

export function useValidationQueueKeyboard(
  families: ValidationIssueFamily[],
  onSelectFamily: (family: ValidationIssueFamily) => void
) {
  const rowRefs = useRef<Record<string, HTMLDivElement | null>>({});

  const moveSelection = useCallback(
    (familyId: string, direction: -1 | 1) => {
      const currentIndex = families.findIndex((family) => family.id === familyId);
      if (currentIndex === -1) {
        return;
      }

      const nextIndex = Math.min(Math.max(currentIndex + direction, 0), families.length - 1);
      if (nextIndex === currentIndex) {
        return;
      }

      const nextFamily = families[nextIndex];
      onSelectFamily(nextFamily);
      requestAnimationFrame(() => {
        rowRefs.current[nextFamily.id]?.focus();
        rowRefs.current[nextFamily.id]?.scrollIntoView({ block: 'nearest' });
      });
    },
    [families, onSelectFamily]
  );

  const setRowRef = useCallback((familyId: string, node: HTMLDivElement | null) => {
    rowRefs.current[familyId] = node;
  }, []);

  return { moveSelection, setRowRef, rowRefs };
}
